let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1;
base = hotelType ? 'https://test.xinjngtech.com/#/?cookType=1' : location.protocol + '//' + domain.replace('crm', 'cms') + '/#/?cookType=1';
export default base;



// WEBPACK FOOTER //
// ./src/api/crmGoBaseurl.js